// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017, 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/*-----------------------------------------------------------------------------
| Variables
|----------------------------------------------------------------------------*/

:root {
  --theia-private-sidebar-tab-width: 48px;
  --theia-private-sidebar-tab-height: 32px;
  --theia-private-sidebar-tab-padding-top-and-bottom: 11px;
  --theia-private-sidebar-tab-padding-left-and-right: 10px;
  --theia-private-sidebar-scrollbar-rail-width: 7px;
  --theia-private-sidebar-scrollbar-width: 5px;
  --theia-private-sidebar-icon-size: 24px;
}

/*-----------------------------------------------------------------------------
| SideBars (left and right)
|----------------------------------------------------------------------------*/

.p-TabBar.theia-app-sides {
  display: block;
  color: var(--theia-activityBar-inactiveForeground);
  background: var(--theia-activityBar-background);
  font-size: var(--theia-ui-font-size1);
  min-width: var(--theia-private-sidebar-tab-width);
  max-width: var(--theia-private-sidebar-tab-width);
}

.p-TabBar-content {
  gap: 4px 0px;
}

.p-TabBar.theia-app-sides .p-TabBar-content {
  z-index: 1;
}

.p-TabBar.theia-app-sides .p-TabBar-tab {
  position: relative;
  background: var(--theia-activityBar-background);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: var(--theia-private-sidebar-tab-height);
  cursor: pointer;
}

.p-TabBar.theia-app-sides .p-TabBar-tab.p-mod-current,
.p-TabBar.theia-app-sides .p-TabBar-tab:hover {
  color: var(--theia-activityBar-foreground);
  background-color: var(--theia-activityBar-activeBackground);
  min-height: var(--theia-private-sidebar-tab-height);
  height: var(--theia-private-sidebar-tab-height);
  border-top: none;
}

.p-TabBar.theia-app-left .p-TabBar-tab.p-mod-current {
  border-top-color: transparent;
  box-shadow: 2px 0 0 var(--theia-activityBar-activeBorder) inset;
}

.p-TabBar.theia-app-right .p-TabBar-tab.p-mod-current {
  border-top-color: transparent;
  box-shadow: -2px 0 0 var(--theia-activityBar-activeBorder) inset;
}

.p-TabBar.theia-app-sides .p-TabBar-tabLabel,
.p-TabBar.theia-app-sides .p-TabBar-tabCloseIcon {
  display: none;
}

/* inactive common icons */
.p-TabBar.theia-app-sides .p-TabBar-tabIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--theia-private-sidebar-icon-size);
  text-align: center;
  color: inherit;

  /* svg */
  width: var(--theia-private-sidebar-tab-width);
  height: var(--theia-private-sidebar-tab-width);
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;
  mask-size: var(--theia-private-sidebar-icon-size);
  -webkit-mask-size: var(--theia-private-sidebar-icon-size);
  mask-position: 50% 50%;
  -webkit-mask-position: 50% 50%;
}

/* inactive legacy/plugin icons */
.p-TabBar.theia-app-sides .p-TabBar-tabIcon:not(.codicon) {
  background: var(--theia-activityBar-inactiveForeground);
}

/* inactive file icons */
.p-TabBar.theia-app-sides .file-icon.p-TabBar-tabIcon {
  background: inherit !important;
}

/* inactive font-awesome icons */
.p-TabBar.theia-app-sides .fa.p-TabBar-tabIcon {
  background: none !important;
}

/* active icons */
.p-TabBar.theia-app-sides .p-TabBar-tabIcon:hover,
.p-TabBar.theia-app-sides .p-mod-current .p-TabBar-tabIcon {
  color: var(--theia-activityBar-foreground);
}

/* active legacy/plugin icons */
.p-TabBar.theia-app-sides .p-TabBar-tabIcon:not(.codicon):hover,
.p-TabBar.theia-app-sides .p-mod-current .p-TabBar-tabIcon:not(.codicon) {
  background-color: var(--theia-activityBar-foreground);
}

.p-TabBar.theia-app-left .p-TabBar-tabLabel {
  transform-origin: top left 0;
  transform: rotate(-90deg) translateX(-100%);
}

.p-TabBar.theia-app-right .p-TabBar-tabLabel {
  transform-origin: top left 0;
  transform: rotate(90deg) translateY(-50%);
}

#theia-left-content-panel.theia-mod-collapsed,
#theia-right-content-panel.theia-mod-collapsed {
  max-width: var(--theia-private-sidebar-tab-width);
}

#theia-left-content-panel > .p-Panel {
  border-right: var(--theia-panel-border-width) solid
    var(--theia-activityBar-border);
}

#theia-right-content-panel > .p-Panel {
  border-left: var(--theia-panel-border-width) solid
    var(--theia-activityBar-border);
}

.theia-side-panel {
  background-color: var(--theia-sideBar-background);
}

.p-Widget.theia-side-panel .p-Widget,
.p-Widget .theia-sidepanel-toolbar {
  color: var(--theia-sideBar-foreground);
}

.theia-app-sidebar-container {
  min-width: var(--theia-private-sidebar-tab-width);
  max-width: var(--theia-private-sidebar-tab-width);
  background: var(--theia-activityBar-background);
  display: flex;
  flex-direction: column;
}

.theia-app-sidebar-container .theia-app-sides {
  flex-grow: 1;
}

.theia-app-sidebar-container .theia-sidebar-menu {
  flex-shrink: 0;
}

.p-Widget.theia-sidebar-menu {
  background-color: var(--theia-activityBar-background);
  display: flex;
  flex-direction: column-reverse;
}

.p-Widget.theia-sidebar-menu i {
  padding: var(--theia-private-sidebar-tab-padding-top-and-bottom)
    var(--theia-private-sidebar-tab-padding-left-and-right);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--theia-activityBar-inactiveForeground);
  background-color: var(--theia-activityBar-background);
  font-size: var(--theia-private-sidebar-icon-size);
}

.theia-sidebar-menu i:hover {
  color: var(--theia-activityBar-foreground);
}

.theia-sidebar-menu > i.codicon-menu {
  font-size: 16px;
}

.p-SplitPanel-handle.sash-hidden {
  visibility: hidden;
}

/*-----------------------------------------------------------------------------
| Perfect scrollbar
|----------------------------------------------------------------------------*/

.p-TabBar.theia-app-sides > .ps__rail-y {
  width: var(--theia-private-sidebar-scrollbar-rail-width);
  z-index: 1000;
}

#theia-app-shell .p-TabBar.theia-app-sides > .ps__rail-y > .ps__thumb-y {
  width: var(--theia-private-sidebar-scrollbar-width);
  right: calc(
    (
        var(--theia-private-sidebar-scrollbar-rail-width) -
          var(--theia-private-sidebar-scrollbar-width)
      ) / 2
  );
}

.p-TabBar.theia-app-sides > .ps__rail-y:hover,
.p-TabBar.theia-app-sides > .ps__rail-y:focus {
  width: var(--theia-private-sidebar-scrollbar-rail-width);
}

.p-TabBar.theia-app-sides > .ps__rail-y:hover > .ps__thumb-y,
.p-TabBar.theia-app-sides > .ps__rail-y:focus > .ps__thumb-y {
  width: var(--theia-private-sidebar-scrollbar-width);
  right: calc(
    (
        var(--theia-private-sidebar-scrollbar-rail-width) -
          var(--theia-private-sidebar-scrollbar-width)
      ) / 2
  );
}

/*-----------------------------------------------------------------------------
| Bottom content panel
|----------------------------------------------------------------------------*/

#theia-bottom-content-panel {
  background: var(--theia-panel-background);
}

#theia-bottom-content-panel .theia-input {
  border-color: var(--theia-panelInput-border);
}

#theia-bottom-content-panel .p-DockPanel-handle[data-orientation="horizontal"] {
  border-left: var(--theia-border-width) solid var(--theia-panel-border);
}

#theia-bottom-content-panel .p-TabBar {
  border-top: var(--theia-border-width) solid var(--theia-panel-border);
  background: inherit;
}

#theia-bottom-content-panel .p-TabBar-tab {
  background: inherit;
}

#theia-bottom-content-panel .p-TabBar-tab:not(.p-mod-current) {
  color: var(--theia-panelTitle-inactiveForeground);
}

#theia-bottom-content-panel .p-TabBar-tab.p-mod-current {
  color: var(--theia-panelTitle-activeForeground);
  box-shadow: 0 var(--theia-border-width) 0 var(--theia-panelTitle-activeBorder)
    inset;
}

#theia-bottom-content-panel
  .p-TabBar:not(.theia-tabBar-active)
  .p-TabBar-tab
  .theia-tab-icon-label {
  color: var(--theia-tab-unfocusedInactiveForeground);
}

#theia-bottom-content-panel
  .p-TabBar:not(.theia-tabBar-active)
  .p-TabBar-tab.p-mod-current
  .theia-tab-icon-label {
  color: var(--theia-tab-unfocusedActiveForeground);
}

/*-----------------------------------------------------------------------------
| Hidden tab bars used for rendering vertical side bars
|----------------------------------------------------------------------------*/

.theia-TabBar-hidden-content {
  display: flex;
  position: absolute;
  visibility: hidden;
  padding-inline-start: 0px;
}

.p-TabBar.theia-app-sides > .theia-TabBar-hidden-content .p-TabBar-tab {
  line-height: var(--theia-private-sidebar-tab-width);
}

.p-TabBar.theia-app-left > .theia-TabBar-hidden-content .p-TabBar-tabLabel {
  transform: none;
}

.p-TabBar.theia-app-right > .theia-TabBar-hidden-content .p-TabBar-tabLabel {
  transform: none;
}

/*-----------------------------------------------------------------------------
| Sidepanel Toolbar
|----------------------------------------------------------------------------*/

.theia-sidepanel-toolbar {
  min-height: calc(
    var(--theia-private-horizontal-tab-height) +
      var(--theia-private-horizontal-tab-scrollbar-rail-height) / 2
  );
  display: flex;
  padding-left: 5px;
  align-items: center;
  background-color: var(--theia-sideBar-background);
}

.theia-sidepanel-toolbar .theia-sidepanel-title {
  color: var(--theia-settings-headerForeground);
  flex: 1;
  margin-left: 14px;
  text-transform: uppercase;
  font-size: var(--theia-ui-font-size0);
  min-width: 1rem;
}

.theia-sidepanel-toolbar .p-TabBar-toolbar .item {
  color: var(--theia-icon-foreground);
}

.theia-sidepanel-toolbar .p-TabBar-toolbar .item > div {
  height: 18px;
  width: 18px;
  background-repeat: no-repeat;
}

.noWrapInfo {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.noWrapInfoTree {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/sidepanel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;;8EAE8E;;AAE9E;EACE,uCAAuC;EACvC,wCAAwC;EACxC,wDAAwD;EACxD,wDAAwD;EACxD,iDAAiD;EACjD,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;;8EAE8E;;AAE9E;EACE,cAAc;EACd,kDAAkD;EAClD,+CAA+C;EAC/C,qCAAqC;EACrC,iDAAiD;EACjD,iDAAiD;AACnD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mDAAmD;EACnD,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,2DAA2D;EAC3D,mDAAmD;EACnD,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,+DAA+D;AACjE;;AAEA;EACE,6BAA6B;EAC7B,gEAAgE;AAClE;;AAEA;;EAEE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;;EAEd,QAAQ;EACR,6CAA6C;EAC7C,8CAA8C;EAC9C,sBAAsB;EACtB,8BAA8B;EAC9B,iDAAiD;EACjD,yDAAyD;EACzD,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,uDAAuD;AACzD;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;;EAEE,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;;EAEE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE;mCACiC;AACnC;;AAEA;EACE;mCACiC;AACnC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,iDAAiD;EACjD,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;2DACyD;EACzD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kDAAkD;EAClD,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;8EAE8E;;AAE9E;EACE,wDAAwD;EACxD,aAAa;AACf;;AAEA;EACE,mDAAmD;EACnD;;;;;GAKC;AACH;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA;;EAEE,mDAAmD;EACnD;;;;;GAKC;AACH;;AAEA;;8EAE8E;;AAE9E;EACE,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;EAC/C;SACO;AACT;;AAEA;;;;EAIE,mDAAmD;AACrD;;AAEA;;;;EAIE,iDAAiD;AACnD;;AAEA;;8EAE8E;;AAE9E;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;8EAE8E;;AAE9E;EACE;;;GAGC;EACD,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;EAC7C,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017, 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n/*-----------------------------------------------------------------------------\n| Variables\n|----------------------------------------------------------------------------*/\n\n:root {\n  --theia-private-sidebar-tab-width: 48px;\n  --theia-private-sidebar-tab-height: 32px;\n  --theia-private-sidebar-tab-padding-top-and-bottom: 11px;\n  --theia-private-sidebar-tab-padding-left-and-right: 10px;\n  --theia-private-sidebar-scrollbar-rail-width: 7px;\n  --theia-private-sidebar-scrollbar-width: 5px;\n  --theia-private-sidebar-icon-size: 24px;\n}\n\n/*-----------------------------------------------------------------------------\n| SideBars (left and right)\n|----------------------------------------------------------------------------*/\n\n.p-TabBar.theia-app-sides {\n  display: block;\n  color: var(--theia-activityBar-inactiveForeground);\n  background: var(--theia-activityBar-background);\n  font-size: var(--theia-ui-font-size1);\n  min-width: var(--theia-private-sidebar-tab-width);\n  max-width: var(--theia-private-sidebar-tab-width);\n}\n\n.p-TabBar-content {\n  gap: 4px 0px;\n}\n\n.p-TabBar.theia-app-sides .p-TabBar-content {\n  z-index: 1;\n}\n\n.p-TabBar.theia-app-sides .p-TabBar-tab {\n  position: relative;\n  background: var(--theia-activityBar-background);\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: var(--theia-private-sidebar-tab-height);\n  cursor: pointer;\n}\n\n.p-TabBar.theia-app-sides .p-TabBar-tab.p-mod-current,\n.p-TabBar.theia-app-sides .p-TabBar-tab:hover {\n  color: var(--theia-activityBar-foreground);\n  background-color: var(--theia-activityBar-activeBackground);\n  min-height: var(--theia-private-sidebar-tab-height);\n  height: var(--theia-private-sidebar-tab-height);\n  border-top: none;\n}\n\n.p-TabBar.theia-app-left .p-TabBar-tab.p-mod-current {\n  border-top-color: transparent;\n  box-shadow: 2px 0 0 var(--theia-activityBar-activeBorder) inset;\n}\n\n.p-TabBar.theia-app-right .p-TabBar-tab.p-mod-current {\n  border-top-color: transparent;\n  box-shadow: -2px 0 0 var(--theia-activityBar-activeBorder) inset;\n}\n\n.p-TabBar.theia-app-sides .p-TabBar-tabLabel,\n.p-TabBar.theia-app-sides .p-TabBar-tabCloseIcon {\n  display: none;\n}\n\n/* inactive common icons */\n.p-TabBar.theia-app-sides .p-TabBar-tabIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--theia-private-sidebar-icon-size);\n  text-align: center;\n  color: inherit;\n\n  /* svg */\n  width: var(--theia-private-sidebar-tab-width);\n  height: var(--theia-private-sidebar-tab-width);\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: var(--theia-private-sidebar-icon-size);\n  -webkit-mask-size: var(--theia-private-sidebar-icon-size);\n  mask-position: 50% 50%;\n  -webkit-mask-position: 50% 50%;\n}\n\n/* inactive legacy/plugin icons */\n.p-TabBar.theia-app-sides .p-TabBar-tabIcon:not(.codicon) {\n  background: var(--theia-activityBar-inactiveForeground);\n}\n\n/* inactive file icons */\n.p-TabBar.theia-app-sides .file-icon.p-TabBar-tabIcon {\n  background: inherit !important;\n}\n\n/* inactive font-awesome icons */\n.p-TabBar.theia-app-sides .fa.p-TabBar-tabIcon {\n  background: none !important;\n}\n\n/* active icons */\n.p-TabBar.theia-app-sides .p-TabBar-tabIcon:hover,\n.p-TabBar.theia-app-sides .p-mod-current .p-TabBar-tabIcon {\n  color: var(--theia-activityBar-foreground);\n}\n\n/* active legacy/plugin icons */\n.p-TabBar.theia-app-sides .p-TabBar-tabIcon:not(.codicon):hover,\n.p-TabBar.theia-app-sides .p-mod-current .p-TabBar-tabIcon:not(.codicon) {\n  background-color: var(--theia-activityBar-foreground);\n}\n\n.p-TabBar.theia-app-left .p-TabBar-tabLabel {\n  transform-origin: top left 0;\n  transform: rotate(-90deg) translateX(-100%);\n}\n\n.p-TabBar.theia-app-right .p-TabBar-tabLabel {\n  transform-origin: top left 0;\n  transform: rotate(90deg) translateY(-50%);\n}\n\n#theia-left-content-panel.theia-mod-collapsed,\n#theia-right-content-panel.theia-mod-collapsed {\n  max-width: var(--theia-private-sidebar-tab-width);\n}\n\n#theia-left-content-panel > .p-Panel {\n  border-right: var(--theia-panel-border-width) solid\n    var(--theia-activityBar-border);\n}\n\n#theia-right-content-panel > .p-Panel {\n  border-left: var(--theia-panel-border-width) solid\n    var(--theia-activityBar-border);\n}\n\n.theia-side-panel {\n  background-color: var(--theia-sideBar-background);\n}\n\n.p-Widget.theia-side-panel .p-Widget,\n.p-Widget .theia-sidepanel-toolbar {\n  color: var(--theia-sideBar-foreground);\n}\n\n.theia-app-sidebar-container {\n  min-width: var(--theia-private-sidebar-tab-width);\n  max-width: var(--theia-private-sidebar-tab-width);\n  background: var(--theia-activityBar-background);\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-app-sidebar-container .theia-app-sides {\n  flex-grow: 1;\n}\n\n.theia-app-sidebar-container .theia-sidebar-menu {\n  flex-shrink: 0;\n}\n\n.p-Widget.theia-sidebar-menu {\n  background-color: var(--theia-activityBar-background);\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.p-Widget.theia-sidebar-menu i {\n  padding: var(--theia-private-sidebar-tab-padding-top-and-bottom)\n    var(--theia-private-sidebar-tab-padding-left-and-right);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: var(--theia-activityBar-inactiveForeground);\n  background-color: var(--theia-activityBar-background);\n  font-size: var(--theia-private-sidebar-icon-size);\n}\n\n.theia-sidebar-menu i:hover {\n  color: var(--theia-activityBar-foreground);\n}\n\n.theia-sidebar-menu > i.codicon-menu {\n  font-size: 16px;\n}\n\n.p-SplitPanel-handle.sash-hidden {\n  visibility: hidden;\n}\n\n/*-----------------------------------------------------------------------------\n| Perfect scrollbar\n|----------------------------------------------------------------------------*/\n\n.p-TabBar.theia-app-sides > .ps__rail-y {\n  width: var(--theia-private-sidebar-scrollbar-rail-width);\n  z-index: 1000;\n}\n\n#theia-app-shell .p-TabBar.theia-app-sides > .ps__rail-y > .ps__thumb-y {\n  width: var(--theia-private-sidebar-scrollbar-width);\n  right: calc(\n    (\n        var(--theia-private-sidebar-scrollbar-rail-width) -\n          var(--theia-private-sidebar-scrollbar-width)\n      ) / 2\n  );\n}\n\n.p-TabBar.theia-app-sides > .ps__rail-y:hover,\n.p-TabBar.theia-app-sides > .ps__rail-y:focus {\n  width: var(--theia-private-sidebar-scrollbar-rail-width);\n}\n\n.p-TabBar.theia-app-sides > .ps__rail-y:hover > .ps__thumb-y,\n.p-TabBar.theia-app-sides > .ps__rail-y:focus > .ps__thumb-y {\n  width: var(--theia-private-sidebar-scrollbar-width);\n  right: calc(\n    (\n        var(--theia-private-sidebar-scrollbar-rail-width) -\n          var(--theia-private-sidebar-scrollbar-width)\n      ) / 2\n  );\n}\n\n/*-----------------------------------------------------------------------------\n| Bottom content panel\n|----------------------------------------------------------------------------*/\n\n#theia-bottom-content-panel {\n  background: var(--theia-panel-background);\n}\n\n#theia-bottom-content-panel .theia-input {\n  border-color: var(--theia-panelInput-border);\n}\n\n#theia-bottom-content-panel .p-DockPanel-handle[data-orientation=\"horizontal\"] {\n  border-left: var(--theia-border-width) solid var(--theia-panel-border);\n}\n\n#theia-bottom-content-panel .p-TabBar {\n  border-top: var(--theia-border-width) solid var(--theia-panel-border);\n  background: inherit;\n}\n\n#theia-bottom-content-panel .p-TabBar-tab {\n  background: inherit;\n}\n\n#theia-bottom-content-panel .p-TabBar-tab:not(.p-mod-current) {\n  color: var(--theia-panelTitle-inactiveForeground);\n}\n\n#theia-bottom-content-panel .p-TabBar-tab.p-mod-current {\n  color: var(--theia-panelTitle-activeForeground);\n  box-shadow: 0 var(--theia-border-width) 0 var(--theia-panelTitle-activeBorder)\n    inset;\n}\n\n#theia-bottom-content-panel\n  .p-TabBar:not(.theia-tabBar-active)\n  .p-TabBar-tab\n  .theia-tab-icon-label {\n  color: var(--theia-tab-unfocusedInactiveForeground);\n}\n\n#theia-bottom-content-panel\n  .p-TabBar:not(.theia-tabBar-active)\n  .p-TabBar-tab.p-mod-current\n  .theia-tab-icon-label {\n  color: var(--theia-tab-unfocusedActiveForeground);\n}\n\n/*-----------------------------------------------------------------------------\n| Hidden tab bars used for rendering vertical side bars\n|----------------------------------------------------------------------------*/\n\n.theia-TabBar-hidden-content {\n  display: flex;\n  position: absolute;\n  visibility: hidden;\n  padding-inline-start: 0px;\n}\n\n.p-TabBar.theia-app-sides > .theia-TabBar-hidden-content .p-TabBar-tab {\n  line-height: var(--theia-private-sidebar-tab-width);\n}\n\n.p-TabBar.theia-app-left > .theia-TabBar-hidden-content .p-TabBar-tabLabel {\n  transform: none;\n}\n\n.p-TabBar.theia-app-right > .theia-TabBar-hidden-content .p-TabBar-tabLabel {\n  transform: none;\n}\n\n/*-----------------------------------------------------------------------------\n| Sidepanel Toolbar\n|----------------------------------------------------------------------------*/\n\n.theia-sidepanel-toolbar {\n  min-height: calc(\n    var(--theia-private-horizontal-tab-height) +\n      var(--theia-private-horizontal-tab-scrollbar-rail-height) / 2\n  );\n  display: flex;\n  padding-left: 5px;\n  align-items: center;\n  background-color: var(--theia-sideBar-background);\n}\n\n.theia-sidepanel-toolbar .theia-sidepanel-title {\n  color: var(--theia-settings-headerForeground);\n  flex: 1;\n  margin-left: 14px;\n  text-transform: uppercase;\n  font-size: var(--theia-ui-font-size0);\n  min-width: 1rem;\n}\n\n.theia-sidepanel-toolbar .p-TabBar-toolbar .item {\n  color: var(--theia-icon-foreground);\n}\n\n.theia-sidepanel-toolbar .p-TabBar-toolbar .item > div {\n  height: 18px;\n  width: 18px;\n  background-repeat: no-repeat;\n}\n\n.noWrapInfo {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.noWrapInfoTree {\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
